import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import FacebookButtonNoConnectTrigger from './trigger/FacebookButtonNoConnectTrigger';

import './facebook-button-no-connect.scss';

import type {
  FacebookButtonNoConnectToggle
} from './types';

interface Props {
  numContentItems?: number,
  toggleOverride?: FacebookButtonNoConnectToggle,
  children: React.ReactNode
}

const FacebookButtonNoConnect: React.FC<Props> = ({
  numContentItems = 1,
  toggleOverride,
  children
}: Props): JSX.Element => {
  const [toggle, setToggle] = React.useState('collapsed' as FacebookButtonNoConnectToggle);

  const contentClasses = classnames('facebook-button-no-connect__content', {
    [`facebook-button-no-connect__content--toggle-${toggle}`]: toggle,
    [`facebook-button-no-connect__content--height-${numContentItems}-channel`]: Boolean(numContentItems)
  });

  React.useEffect(() => {
    if (!isNil(toggleOverride)) {
      setToggle(toggleOverride as FacebookButtonNoConnectToggle);
    }
  }, [toggleOverride]);

  const handleToggleChange = (
    value: FacebookButtonNoConnectToggle
  ): void => {
    setToggle(value);
  };

  return (
    <div className="facebook-button-no-connect">
      <FacebookButtonNoConnectTrigger
        toggle={toggle}
        onToggle={handleToggleChange}
      />
      <div className={contentClasses}>
        {children}
      </div>
    </div>
  );
};

export default FacebookButtonNoConnect;
